module.exports = "../../../../platform/assets/pageMainIcon/industry_jichudanganlei3.svg";